import React from "react";

import { isWebpSupported } from "react-image-webp/dist/utils";

import Section from "../components/blocks/Section";
import IntroTitle from "../components/texting/IntroTitle";
import IntroSubTitle from "../components/texting/IntroSubTitle";

const Intro = (props) => {
  const {
    color,
    background,
    id,
    social,
    animations,
    col,
    desktop,
    mobile,
    personage,
    personage_webp,
    personage_mobile,
    personage_mobile_webp,
    children,
  } = props;

  function _renderObject(obj) {
    return Object.entries(obj).map(([key, value], i) => {
      if (value.type === "title") {
        return (
          <IntroTitle
            fontSize={value.fontSize}
            lineHeight={value.lineHeight}
            key={i}
          >
            {value.value}
          </IntroTitle>
        );
      } else if (value.type === "subtitle") {
        return (
          <IntroSubTitle
            fontSize={value.fontSize}
            lineHeight={value.lineHeight}
            key={i}
          >
            {value.value}
          </IntroSubTitle>
        );
      } else if (value.type === "button") {
        return value.value;
      }
      return null;
    });
  }

  var personage_image;

  if (personage_mobile_webp && window.innerWidth <= 400) {
    personage_image = isWebpSupported() ? (
      <img
        className="personage"
        id="personage"
        src={personage_mobile_webp}
        alt={mobile["1"].value}
      />
    ) : (
      <img
        className="personage"
        src={personage_mobile}
        alt={desktop["1"].value}
      />
    );
  } else if (personage_webp) {
    personage_image = isWebpSupported() ? (
      <img
        className="personage"
        id="personage"
        src={personage_webp}
        alt={mobile["1"].value}
      />
    ) : (
      <img className="personage" src={personage} alt={desktop["1"].value} />
    );
  }

  return (
    <Section
      color={color || "gray"}
      background={background}
      layout="container"
      id={id}
      prechildren={
        <div className="decorations">
          {/* <div className="action"><span className="scroll-line"></span></div> */}
          {social ? (
            <div className="social-icons">
              <a
                id="social_media_fb"
                target="_blank"
                rel="noopener noreferrer nofollow"
                href="https://www.facebook.com/weprodigi/"
              >
                <span></span>
              </a>
              <a
                id="social_media_insta"
                target="_blank"
                rel="noopener noreferrer nofollow"
                href="https://www.instagram.com/weprodigi_agency/"
              >
                <span></span>
              </a>
              <a
                id="social_media_linkedin"
                target="_blank"
                rel="noopener noreferrer nofollow"
                href="https://www.linkedin.com/company/weprodigiagency/"
              >
                <span></span>
              </a>
              <a
                id="social_media_youtube"
                target="_blank"
                rel="noopener noreferrer nofollow"
                href="https://www.youtube.com/channel/UC6mkepDFKswxQWS76hgOMBg"
              >
                <span></span>
              </a>
              <a
                id="social_media_x"
                target="_blank"
                rel="noopener noreferrer nofollow"
                href="https://x.com/WeProdigi"
              >
                <span></span>
              </a>
            </div>
          ) : null}

          <div className="black"></div>
          <div className="ruller"></div>
          <div className="personage-container">
            {personage_image}
            {animations}
          </div>
        </div>
      }
    >
      <div
        className="row align-items-center intro-row"
        style={window.innerWidth < 1000 ? { height: "50%" } : {}}
      >
        {window.innerWidth > 1000 ? (
          <div className={"col-lg-" + (col || 8) + " intro-texts text-left"}>
            {desktop ? <h1>{_renderObject(desktop)} </h1> : null}
          </div>
        ) : (
          <div className="col-lg-6 intro-texts text-left">
            {/* <div className="text1"></div> */}

            {mobile ? <h1>{_renderObject(mobile)} </h1> : null}
          </div>
        )}
      </div>
      {children}
    </Section>
  );
};

export default Intro;
